import axios from 'axios'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { useDefaultTradeName } from '../../../hooks/useDefaultTradeName'
import { fetchZervantInvoiceLogoUrl } from '../query-api'

const isLogoNotFoundError = (error: unknown): boolean => axios.isAxiosError(error) && error.response?.status === 404

export const useZervantInvoiceLogoUrl = () => {
  const { defaultTradeName, isLoading: isLoadingDefaultTradeName } = useDefaultTradeName()

  const defaultTradeNameId = defaultTradeName?._id

  const {
    data: logoData,
    isLoading: isLoadingLogoUrl,
    ...rest
  } = useQuery(
    [QueryKeys.ZervantInvoiceLogo, defaultTradeNameId],
    async () => {
      try {
        return await fetchZervantInvoiceLogoUrl(defaultTradeNameId || '')
      } catch (fetchError) {
        // A 404 is an answer, not a failure: the trade name has no logo.
        if (isLogoNotFoundError(fetchError)) {
          return null
        }

        throw fetchError
      }
    },
    {
      enabled: !!defaultTradeNameId,
      // Retries are disabled because the request returns a 404 when no logo is available.
      // By default, React Query retries such errors 3–5 times, causing unnecessary delays and a longer loading state.
      // This can be removed later if the platform service is updated to avoid returning 404 in this case.
      retry: false,
    },
  )

  return { logoUrl: logoData?.data?.url, isLoading: isLoadingDefaultTradeName || isLoadingLogoUrl, ...rest }
}
